/**
 * Lightbox for FN EU Legal Guarantee Notice image.
 * Uses native <dialog>: open trigger, close button, backdrop click; Esc is native.
 */
(function () {
  function initLightbox(root) {
    const dialog = root.querySelector('[data-foodnova-eu-lightbox]');
    const openBtn = root.querySelector('[data-foodnova-eu-lightbox-open]');
    if (!dialog || !openBtn || typeof dialog.showModal !== 'function') return;

    openBtn.addEventListener('click', () => {
      if (!dialog.open) dialog.showModal();
    });

    dialog.querySelectorAll('[data-foodnova-eu-lightbox-close]').forEach((btn) => {
      btn.addEventListener('click', () => dialog.close());
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  }

  function boot() {
    document.querySelectorAll('.foodnova-eu-legal-guarantee-notice').forEach(initLightbox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
